import { render } from "./documentsTab.vue?vue&type=template&id=524aaeba&scoped=true"
import script from "./documentsTab.vue?vue&type=script&lang=ts"
export * from "./documentsTab.vue?vue&type=script&lang=ts"

import "./documentsTab.vue?vue&type=style&index=0&id=524aaeba&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-524aaeba"

export default script